import React, { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router";

import MainFrame from "@/Layout/Layout";
import Notfound from "./pages/Notfound/NotFoundView";
import HomeView from "@/pages/home/HomeView";

// Code-split: cada rota vira um chunk separado, reduzindo o bundle inicial
const ContactUsView = lazy(() => import("@pages/contact/ContactUsView"));
const PortfolioView = lazy(() => import("@pages/portfolio/PortfolioView"));
const AboutUsView = lazy(() => import("@pages/about/AboutUsView"));
const ComplianceView = lazy(() => import("@pages/compliance/ComplianceView"));
const IndividualProductView = lazy(
  () => import("@pages/portfolio/IndividualProductView"),
);

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<div className="min-h-screen" />}>{element}</Suspense>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeView />,
  },
  {
    path: "/contact-us",
    element: withSuspense(<ContactUsView />),
  },
  {
    path: "/about-us",
    element: withSuspense(<AboutUsView />),
  },
  {
    path: "/compliance",
    element: withSuspense(<ComplianceView />),
  },
  {
    path: "/portfolio",
    element: withSuspense(<PortfolioView />),
  },
  {
    path: "/portfolio/:productId",
    element: withSuspense(<IndividualProductView />),
  },
  {
    path: "*",
    element: (
      <MainFrame>
        <Notfound />
      </MainFrame>
    ),
  },
]);

export default router;
